class LearningAreaService {
    constructor($http, $q) {
        let self = this;

        self.list = function() {
            return $http({
                method: 'GET',
                url: './api/learning_area',
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                data: {}
            }).then((res => res.data), (error) => $q.reject(error));
        };

        self.getById = function(id) {
            return $http({
                method: 'GET',
                url: './api/learning_area/' + id,
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                data: {}
            }).then((res => res.data), (error) => $q.reject(error));
        };

        self.save = function(learningArea) {
            return $http.post('/api/learning_area/' + learningArea.id, learningArea, {
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                }
            }).then((res => res.data), (error) => $q.reject(error));
        };

        self.create = function(learningArea) {
            return $http.post('/api/learning_area', learningArea, {
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                }
            }).then((res => res.data), (error) => $q.reject(error));
        };

        self.delete = function(id) {
            return $http({
                method: 'DELETE',
                url: '/api/learning_area/' + id,
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                data: {}
            }).then((res => res.data), (error) => $q.reject(error));
        };
    }
}

export default LearningAreaService;




// WEBPACK FOOTER //
// ./src/app/pages/evaluation/services/learningAreaService.js